<template>
    <section>
       <v-btn color='primary' @click="ResultUpload">Upload CSV</v-btn>
       <a :href="GetProductionURL" target="_blank">Download Sample CSV</a>
       <app-result-upload ref="UploadResult" :dialog='ResultDialog' @close='ResultDialog = false'></app-result-upload>
       <app-table></app-table>
    </section>
</template>
<script>
import appResultUpload from '../views/dialogs/ResultUpload'
import appTable        from '../views/tables/ResultUploadTable'
export default {
    components:{
      appResultUpload,
      appTable
    },
     data() {
        return {
            ResultDialog : false
        };
    },
    computed:{
      GetProductionURL(){
          return `${this.$store.getters.GetProductionUrl}/static/MOCK_DATA.csv` 
      }
    },
    methods: {
      ResultUpload(){

        this.$refs.UploadResult.FetchCompanyList();
        this.ResultDialog = true
      }
    },
    mounted(){
      this.$eventHub.$emit("LOADING",'false')
    }
}
</script>
<style>

</style>